// reason: no specific data type for intTelInput plugin and angular built in function
/* eslint-disable @typescript-eslint/no-explicit-any */
import {
    Component,
    Input,
    ElementRef,
    ViewChild,
    PLATFORM_ID,
    Inject,
    forwardRef,
    OnInit,
    Renderer2,
    Output,
    EventEmitter,
} from '@angular/core';
import {
    COUNTRY_DIAL_CODES,
    DIGIT_ONLY_PATTERN,
    GLOBAL_TEL_INPUT_SIZE,
    MY_DIAL_CODE,
    MY_TEL_INPUT_SIZE,
} from '../../../../constants/app.constant';
import { isPlatformBrowser } from '@angular/common';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import intlTelInput from 'intl-tel-input';
import { PhoneValidationErrorCode } from '../../../../enum/ui-utils.enum';

@Component({
    selector: 'app-intl-tel-number-input',
    templateUrl: './intl-tel-number-input.component.html',
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => IntlTelNumberInputComponent),
            multi: true,
        },
    ],
})
export class IntlTelNumberInputComponent implements OnInit, ControlValueAccessor {
    @ViewChild('phoneInput', { static: true }) phoneInput!: ElementRef;

    @Input() onlyCountries: string[] = COUNTRY_DIAL_CODES;
    @Input() initialCountry = COUNTRY_DIAL_CODES[0];
    @Input() inputClass = 'form-control form-textbox';
    @Input() placeholder = 'Enter phone number';
    @Output() updateValidation = new EventEmitter<PhoneValidationErrorCode>();

    protected phoneNumberErrorCode = Number(PhoneValidationErrorCode.Null);

    protected phoneNumberMaxLength = MY_TEL_INPUT_SIZE;
    protected DIGIT_ONLY_PATTERN = DIGIT_ONLY_PATTERN;

    protected PhoneValidationErrorCode = PhoneValidationErrorCode;

    private isBrowser = false;
    private iti!: any;

    constructor(
        private renderer: Renderer2,
        @Inject(PLATFORM_ID) private platformId: object,
    ) {
        this.isBrowser = isPlatformBrowser(platformId);
    }

    ngOnInit(): void {
        if (this.isBrowser) {
            this.updatePhoneNumberMaxLength(this.initialCountry);
            this.constructIntlTelInput();
        }
    }

    writeValue(value: any): void {
        if (this.isBrowser) {
            this.renderer.setProperty(this.phoneInput.nativeElement, 'value', value);
            this.iti.setNumber(value);
        }
    }

    checkPhoneValidation(): void {
        this.updateValidation.emit(this.iti.getValidationError());
    }

    registerOnChange(fn: any): void {
        this.onChange = fn;
    }

    registerOnTouched(fn: any): void {
        this.onTouched = fn;
    }

    setDisabledState?(isDisabled: boolean): void {
        this.renderer.setProperty(this.phoneInput.nativeElement, 'disabled', isDisabled);
    }

    private onChange: any = () => {};
    private onTouched: any = () => {};

    private constructIntlTelInput(): void {
        const input = this.phoneInput.nativeElement as HTMLInputElement;

        this.iti = intlTelInput(input, {
            onlyCountries: this.onlyCountries,
            initialCountry: this.initialCountry,
            allowDropdown: true,
            separateDialCode: true,
            utilsScript: '/assets/js/utils.js',
        });

        input.addEventListener('countrychange', () => {
            const selectedCountryData = this.iti.getSelectedCountryData();

            this.updatePhoneNumberMaxLength(selectedCountryData.iso2);
            this.onChange(this.iti.getNumber());
        });

        input.addEventListener('blur', () => {
            this.onTouched();
            this.onChange(this.iti.getNumber());
        });
    }

    private updatePhoneNumberMaxLength(countryCode: string): void {
        this.phoneNumberMaxLength = countryCode === MY_DIAL_CODE ? MY_TEL_INPUT_SIZE : GLOBAL_TEL_INPUT_SIZE;
    }
}
